import { useAccount } from 'wagmi';
import { useNFTPurchase } from '../hooks/useNFTPurchase';

export default function NFTCard({ nft, onPurchaseSuccess, isOwned }) {
  const { isConnected } = useAccount();

  const {
    purchaseState,
    error,
    handlePurchase,
    resetPurchase,
    isLoading,
  } = useNFTPurchase(nft.tokenId, nft.price, onPurchaseSuccess);

  const getButtonText = () => {
    if (isOwned) return 'Already Owned';
    if (!isConnected) return 'Connect Wallet First';
    if (purchaseState === 'checking') return 'Checking...';
    if (purchaseState === 'approving') return 'Approving...';
    if (purchaseState === 'buying') return 'Purchasing...';
    if (purchaseState === 'confirming') return 'Confirming...';
    if (purchaseState === 'success') return 'Purchase Successful!';
    if (purchaseState === 'error') return 'Try Again';
    return 'Purchase';
  };

  const handleButtonClick = () => {
    if (purchaseState === 'error') {
      resetPurchase();
    } else {
      handlePurchase();
    }
  };

  const isButtonDisabled = !isConnected || isOwned || isLoading || purchaseState === 'success';

  return (
    <div className="bg-primary-light border border-secondary/30 rounded-lg shadow-lg shadow-secondary/10 overflow-hidden hover:shadow-cyan-glow-lg hover:border-secondary/60 transition-all">
      <img
        src={
          nft.imageUrl
            ? nft.imageUrl.replace("ipfs://", "https://ipfs.io/ipfs/")
            : "/placeholder.svg"
        }
        alt={nft.name}
        className="w-full h-48 object-cover"
      />
      <div className="p-4">
        <h3 className="text-lg font-semibold text-text-primary mb-2">{nft.name}</h3>
        <p className="text-sm text-text-secondary mb-3 line-clamp-2">{nft.description}</p>
        <div className="flex justify-between items-center mb-3">
          <span className="text-xl font-bold text-secondary">${nft.price}</span>
          <span className="text-xs text-text-secondary">by {nft.creator?.username}</span>
        </div>

        {error && (
          <div className="mb-2 p-2 bg-red-500/10 border border-red-500/30 rounded text-red-400 text-xs">
            {error}
          </div>
        )}

        {purchaseState === 'success' && (
          <div className="mb-2 p-2 bg-green-500/10 border border-green-500/30 rounded text-green-400 text-xs">
            Purchase confirmed on blockchain!
          </div>
        )}

        <button
          onClick={handleButtonClick}
          disabled={isButtonDisabled}
          className={`w-full py-2 rounded-lg font-semibold transition-all ${isOwned || purchaseState === 'success'
              ? "bg-secondary/20 text-secondary/50 border border-secondary/30 cursor-not-allowed blur-[0.5px]"
              : !isConnected
                ? "bg-yellow-500/20 text-yellow-400 border border-yellow-500/30 cursor-not-allowed"
                : purchaseState === 'error'
                  ? "bg-red-500/20 text-red-400 border border-red-500/30 hover:bg-red-500/30 cursor-pointer"
                  : "bg-secondary text-primary hover:bg-secondary-light hover:shadow-cyan-glow disabled:opacity-50 disabled:cursor-not-allowed"
            }`}
        >
          {getButtonText()}
        </button>

        {isLoading && (
          <div className="mt-2 flex items-center justify-center gap-2 text-xs text-text-secondary">
            <div className="animate-spin h-3 w-3 border-2 border-secondary border-t-transparent rounded-full" />
            <span>Processing transaction...</span>
          </div>
        )}
      </div>
    </div>
  )
}
